import React, { useState, useEffect } from "react";
import client from "../../components/contentful/Contentful";
import Link from "next/link";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import MainLayout from "../../components/MainLayout/MainLayout";
import Head from "next/head";
import { appServerSideProps } from "../../utils/getAppService";
import { WINNING_METRICS } from "../../components/WinningMetrics";
export const mapTargetSiteToURL = (targetSite) => {
  const urlMap = {
    BestBets: "/ncaa/best-bets",
    BettingAnalysis: "/ncaa/betting-results",
    BettingRecord: "/ncaa/betting-record",
    Glossary: "/glossary",
    Matchups: "/ncaa/matchup-tool",
    ModelSandbox: "/ncaa/model-sandbox",
    PlayerDetails: "/ncaa/player-stats",
    PlayerProps: "/nba/picks/playerprops",
    Players: "/nba/picks/playerprops",
    Projections: "/ncaa/linevalue",
    Results: "/ncaa/betting-results",
    Scores: "/ncaa/shotquality-scores",
    Standings: "/ncaa/team-standings",
    TeamStandings: "/ncaa/team-standings",
    TrendFinder: "/ncaa/trend-finder",
    Trends: "/ncaa/trend-finder",
    TeamPage: "/team/ncaa/2026/Connecticut",
    ScoreCenter: "/ncaa/shotquality-scores",
    LiveQueryTool: "/ncaa/live-query-tool",
    StatsExplained: "/stats-explained",
  };
  if (!urlMap[targetSite]) {
    return "/glossary";
  }
  return urlMap[targetSite];
};

const WinningMetricsGlossary = ({ user, winningMetrics }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredMetrics = WINNING_METRICS.filter((metric) => {
    const metricName = metric.name ? metric.name.toLowerCase() : "";
    const definitionText = metric.definition.toLowerCase();
    return metricName.includes(searchTerm.toLowerCase()) || definitionText.includes(searchTerm.toLowerCase());
  });

  return (
    <>
      <Head>
        <title>Glossary | ShotQualityBets </title>
      </Head>
      <MainLayout>
        <div className="container mt-5">
          <p>
            <Link className="color-orange is-link" href="/glossary">
              Winning Metrics{" "}
            </Link>
            &gt;
          </p>
          <div className="text-center mb-5">
            <h1 className="text-uppercase color-orange mt-5 fw-9">Betting Winning Metrics Glossary</h1>
            <p>Analyze your favorite team and favorite bets using the best data in basketball.</p>
          </div>
          {/* Search Input */}
          <input
            type="text"
            placeholder="Search Metrics..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="form-control mb-5"
            style={{ maxWidth: "35rem", margin: "auto" }}
          />

          <div className="row">
            {filteredMetrics.map((metric, index) => (
              <div className="col-lg-4 col-md-6 col-12 mb-4" key={index}>
                <Link href={`/glossary/` + encodeURIComponent(metric.name)}>
                  <div className="card text-center p-4 mb-4 border-radius-10 h-100 d-flex justify-content-around glow-border">
                    <h4>{metric.name}</h4>
                    <div className="text-black" style={{ whiteSpace: "pre-line" }}>
                      {metric.definition}
                    </div>
                    {/* {metric.fields.targetSite && metric.fields.targetPage && (
                    <p>
                      <strong>Used On: </strong>
                      {metric.fields.targetPage.map((site) => (
                        <Link
                          className="glossary-target-page"
                          target="_blank"
                          href={mapTargetSiteToURL(site)}
                          key={site}
                        >
                          {site}
                          {metric.fields.targetPage[metric.fields.targetPage.length - 1] === site ? " " : ", "}
                        </Link>
                      ))}
                    </p>
                  )} */}
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default WinningMetricsGlossary;

// export const getServerSideProps = appServerSideProps(async ({ appService }) => {
//   const isUserLogged = appService.getUser();

//   let user = null;

//   if (isUserLogged) {
//     user = await appService.get("api/account");
//   }

//   const winningMetrics = await client.getEntries({
//     content_type: "winningMetrics",
//     "fields.targetSite[in]": "ShotQualityBets",
//     "fields.targetPage": "Glossary",
//   });

//   return { props: { user, winningMetrics: winningMetrics?.items } };
// });
